import React, { useState, useEffect } from 'react';
import {
  Rating,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import styles from './styles';

const Contact = function Contact() {
  const [rating, setRating] = useState(2.5);
  const [open, setOpen] = useState(false);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [distance, setDistance] = useState(null);  // Distance en kilomètres

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = () => {
    console.log("Note: " + rating);
    handleClose();
  };

  // Coordonnées fixes du restaurant
  const restaurantCoords = {
    latitude: 46.1418341,
    longitude: -1.1518132,
  };

  // Calcul de la distance entre deux coordonnées géographiques en kilomètres
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Rayon de la Terre en kilomètres
    const φ1 = (lat1 * Math.PI) / 180; // Convertir en radians
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance en kilomètres
    return distance;
  };

  useEffect(() => {
    if (navigator.geolocation) {
      const geoWatchId = navigator.geolocation.watchPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });

          // Calculer la distance à chaque mise à jour de la position
          const dist = calculateDistance(latitude, longitude, restaurantCoords.latitude, restaurantCoords.longitude);
          setDistance(dist.toFixed(2));  // Arrondir à deux décimales
        },
        (error) => {
          console.error("Erreur de géolocalisation: ", error);
          alert("Impossible de récupérer la géolocalisation.");
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );

      return () => navigator.geolocation.clearWatch(geoWatchId);
    } else {
      alert("Géolocalisation non supportée par votre navigateur.");
    }
  }, []);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Le restaurant Antinea</h1>
      <p>
        {location.latitude && location.longitude ? (
          <>
            <strong>Géolocalisation actuelle :</strong><br />
            Latitude: {location.latitude} <br />
            Longitude: {location.longitude} <br />
            <strong>Distance au restaurant :</strong> {distance ? `${distance} km` : 'Calcul en cours...'}
          </>
        ) : (
          <p>Chargement de la géolocalisation...</p>
        )}
      </p>
      <p>Coordonnées latitude, longitude du restaurant Antinea
      <br/>(46.1418341, -1.1518132)</p>
      <p>
        Type de restauration : Brasserie, pizzeria
        <br />
        Accessible aux personnes à mobilité réduite
        <br />
        WIFI disponible
        <br />
        Modes de paiement : CB, Izly
      </p>
      <h2>Horaires</h2>
      <p>11h30-13h45</p>
      <h2>Accès</h2>
      <p>
        15 rue Vaux de Foletier 17000 LA ROCHELLE
        <br />
        Téléphone : 05.46.44.18.57
      </p>
      <h2>Avis</h2>
      <p>Note globale : 4.2 ⭐</p>
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', margin: '1rem' }}>
        <Button variant='outlined' onClick={handleClickOpen} style={{ color: "black", backgroundColor: "orange" }}>
          Votez !
        </Button>
      </div>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Votre avis nous intéresse !</DialogTitle>
        <DialogContent>
          <Rating
            name='popup-rating'
            value={rating}
            precision={0.5}
            onChange={(event, newValue) => setRating(newValue)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button onClick={handleSubmit}>Valider</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Contact;
